module.exports = __webpack_public_path__ + "static/media/ECO-on.6cd8f489.svg";